import { render, staticRenderFns } from "./Workload.vue?vue&type=template&id=743045c7&"
import script from "./Workload.vue?vue&type=script&lang=js&"
export * from "./Workload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports